var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format';
import isEmpty from 'lodash/isEmpty';
import { TextInput } from '../TextInput';
var useStyles = makeStyles(function () { return ({
    root: function (props) { return ({
        '& input': {
            padding: props.inputPadding || '6px 0 7px',
        },
    }); },
    input: function (props) { return ({
        textAlign: props.alignText || 'initial',
    }); },
}); });
// Todo: We should move it into helper repo
var countDecimal = function (value) {
    if (!value || Math.floor(value) === value)
        return 0;
    return value.toString().split('.')[1].length || 0;
};
// eslint-disable-next-line max-len
var isDynamicDecimalPlace = function (value, minDecimalScale) {
    return countDecimal(value) < minDecimalScale;
};
/**
 * @deprecated
 * Use `DecimalInput` to render a decimal input inside your project
 */
var DecimalInput = function (_a) {
    var _b = _a.value, value = _b === void 0 ? undefined : _b, onChange = _a.onChange, onBlur = _a.onBlur, disabled = _a.disabled, _c = _a.decimalScale, decimalScale = _c === void 0 ? 2 : _c, _d = _a.minDecimalScale, minDecimalScale = _d === void 0 ? 0 : _d, _e = _a.placeholder, placeholder = _e === void 0 ? '0.00' : _e, max = _a.max, min = _a.min, prefix = _a.prefix, suffix = _a.suffix, name = _a.name, _f = _a.negative, negative = _f === void 0 ? false : _f, onValueChange = _a.onValueChange, onFocusProp = _a.onFocus, onKeyDownProp = _a.onKeyDown, autoFocus = _a.autoFocus, otherProps = __rest(_a, ["value", "onChange", "onBlur", "disabled", "decimalScale", "minDecimalScale", "placeholder", "max", "min", "prefix", "suffix", "name", "negative", "onValueChange", "onFocus", "onKeyDown", "autoFocus"]);
    var _g = useState(false), focus = _g[0], setFocus = _g[1];
    var isDynamic = !focus && isDynamicDecimalPlace(value, minDecimalScale);
    var classes = useStyles(otherProps);
    var floatValue = null;
    var inputComponentRef = useRef(null);
    useEffect(function () {
        var _a;
        autoFocus && ((_a = inputComponentRef === null || inputComponentRef === void 0 ? void 0 : inputComponentRef.current) === null || _a === void 0 ? void 0 : _a.select());
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [inputComponentRef]);
    var isAllowed = function (_a) {
        var formattedFloatValue = _a.floatValue;
        if (isEmpty(max) && formattedFloatValue > max) {
            return false;
        }
        return !(isEmpty(min) && formattedFloatValue < min);
    };
    var mutatedTarget = function (event) {
        if (event) {
            // eslint-disable-next-line no-param-reassign
            event.target = __assign(__assign({}, event.target), { value: floatValue !== null ? "".concat(floatValue) : value || event.target.value, name: name, type: 'number' });
        }
        return event;
    };
    return (React.createElement(NumberFormat, __assign({ defaultValue: 0, classes: {
            root: classes.root,
            input: classes.input,
        }, decimalScale: isDynamic ? minDecimalScale : decimalScale, customInput: TextInput, placeholder: placeholder, onValueChange: function (values) {
            onValueChange && onValueChange(values.floatValue);
            /*
             @todo convert this to use a HOC that mutates event values and the value given and put the
             logic for this in there and migrate place that use negative prop to use that
             */
            floatValue = negative ? -1 * values.floatValue : values.floatValue;
        }, onBlur: function (event) {
            setFocus(false);
            var mutatedEvent = mutatedTarget(event);
            onBlur && onBlur(mutatedEvent);
            onChange && onChange(mutatedEvent);
        }, onFocus: function (ev) {
            setFocus(true);
            if (onFocusProp)
                onFocusProp(ev);
        }, onChange: function (event) {
            var mutatedEvent = mutatedTarget(event);
            if (!isNaN(mutatedEvent.target.value)) {
                onChange && onChange(mutatedEvent);
            }
        }, disabled: disabled, onKeyDown: onKeyDownProp, value: negative ? -value : value, isAllowed: isAllowed, prefix: prefix, suffix: suffix, fixedDecimalScale: isDynamic, name: name, getInputRef: function (el) {
            inputComponentRef.current = el;
        } }, otherProps)));
};
export default DecimalInput;
//# sourceMappingURL=DecimalInput.js.map